<script setup>
import { computed } from 'vue'
import { getI18n } from '@/plugins/i18n'

import { useReportColumnTemplates } from '@/composables/report-column-template'

import PrintOptionToggles from '@/components/shared/PrintOptionToggles.vue'

const props = defineProps({
  modelValue: {
    type: Object,
    required: true,
  },
  disable: {
    type: Boolean,
    required: false,
    default: false,
  },
})

const emit = defineEmits(['update:modelValue'])

const i18n = getI18n()
const { sectionsOf, enabledSections } = useReportColumnTemplates()

const enabledKeys = computed(() => enabledSections(props.modelValue).map(section => section.key))
const options = computed(() => sectionsOf(props.modelValue.document_type).filter(section => !section.required).map(section => ({
  key: section.key,
  label: i18n.t(section.label),
  value: enabledKeys.value.includes(section.key),
  disable: props.disable || (enabledKeys.value.length === 1 && enabledKeys.value.includes(section.key)),
})))

const onToggled = (key, value) => emit('update:modelValue', {
  ...props.modelValue,
  sections: { ...props.modelValue.sections, [key]: { ...props.modelValue.sections[key], enabled: value } },
})
</script>
<template>
  <div v-if="options.length > 1">
    <div class="text-caption text-grey-7">{{ i18n.t('common.report.sections') }}</div>
    <print-option-toggles :options="options" @update="onToggled" />
    <q-separator class="q-my-sm" />
  </div>
</template>
